import {
    FormError,
    FormErrors,
    FormValidation,
    validateForm,
} from '../../../../entities/@forms/FormValidation/FormValidationService';
import trans from '../../../../helpers/trans';

export interface ProductQuantityValidationData {
    quantity: number;
    stock: number;
}

export interface ProductQuantitySubmitFormData {
    cartItemId: string;
    quantity: number;
}

export type ProductQuantityErrors = FormErrors<ProductQuantityValidationData>;

const validateProductQuantityIsInStock = (quantity: number, stock: number): FormError => {
    if (quantity > stock) {
        return trans('errors.fewProductsAvailable', { stock });
    }

    return undefined;
};

export const validateProductQuantity = (formData: ProductQuantityValidationData): FormValidation<ProductQuantityErrors> => {
    const errors: ProductQuantityErrors = {
        quantity: validateProductQuantityIsInStock(formData.quantity, formData.stock),
    };

    return validateForm<ProductQuantityErrors>(errors);
};
